/**
 * ステータス: 未対応
 */
export const PROFESSIONAL_LIST_STATUS_OPEN = {
    label: '未対応',
    value: 'OPEN',
};
/**
 * ステータス: 回答済
 */
export const PROFESSIONAL_LIST_STATUS_ANSWERED = {
    label: '回答済',
    value: 'ANSWERED',
};
/**
 * ステータス: 募集終了
 */
export const PROFESSIONAL_LIST_STATUS_CLOSED = {
    label: '募集終了',
    value: 'CLOSED',
};
/**
 * 匿名ホットライン開示ステータス一覧
 */
export const PROFESSIONAL_LIST_STATUSES = [
    PROFESSIONAL_LIST_STATUS_OPEN,
    PROFESSIONAL_LIST_STATUS_ANSWERED,
    PROFESSIONAL_LIST_STATUS_CLOSED,
];
